import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownloadIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 29.227 33.167",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M77.9,379.482h29.227v3.685H77.9Zm21.92-11.056-7.307,7.37-7.307-7.37h5.48V350H94.34v18.426Z",
		transform: "translate(-77.9 -350)"
	})
});
export default SvgDownloadIcon;
